import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-center gap-1'
  },
  variants: {},
  defaultVariants: {}
});
